<div class="flex justify-center">
  <div class="w-full py-12 px-18.5">
    <form [formGroup]="form" class="flex flex-col gap-2">
      @if (isGenerating()) {
        <p-skeleton height="200px" width="100%" styleClass="rounded-xl" />
      } @else {
        <div
          class="w-full h-[200px] rounded-xl bg-gray-100 animate-pulse"></div>
      }
      <!-- TODO: remove ! from !text-* when bootstrap.css is removed. -->
      <input
        type="text"
        pInputText
        [pAutoFocus]="true"
        fluid="true"
        autocomplete="off"
        placeholder="Podcast series title *"
        class="!text-3xl !border-none !shadow-none"
        [readonly]="isGenerating() ? 'readonly' : null"
        formControlName="title" />
      <!-- TODO: remove ! from !text-* when bootstrap.css is removed. -->
      <input
        type="text"
        pInputText
        autocomplete="off"
        fluid="true"
        placeholder="What's your podcast about? *"
        class="!text-5xl !border-none !shadow-none"
        [readonly]="isGenerating() ? 'readonly' : null"
        formControlName="subject" />

      @if (!isGenerating()) {
        <div class="flex justify-between items-center">
          <div class="flex gap-2">
            <p-button
              label="Customize"
              size="large"
              variant="outlined"
              [rounded]="true"
              icon="pi pi-cog"
              severity="secondary"
              [disabled]="isGenerating()"
              (click)="handleSettingsClick()" />
            <app-sources-button
              label="Sources"
              [sources]="this.form.get('sources').value"
              [maxSourceItems]="maxSourceItems"
              [disabled]="isGenerating()"
              (sourcesChange)="onSourcesChange($event)" />
            <p-button
              label="Generate"
              size="large"
              icon="pi pi-arrow-right"
              iconPos="right"
              [severity]="form.invalid ? 'secondary' : 'primary'"
              [disabled]="form.invalid || isGenerating()"
              (click)="goToScript()"
              rounded />
          </div>
          <app-prompt-language-picker
            [disabled]="isGenerating()"
            [value]="this.form.get('promptLanguage').value"
            (valueChange)="onPromptLanguageChange($event)" />
        </div>
        <div class="mt-2">
          <app-brainstorm-concepts
            [subject]="form.get('subject').value"
            [customInstruction]="form.get('customInstruction').value" />
        </div>
      } @else {
        <div class="flex items-center justify-center p-4 bg-gray-50 rounded-lg">
          <i class="pi pi-spin pi-spinner mr-2 text-primary text-xl"></i>
          <span class="font-medium">
            Generating your podcast content (may take 3-5 minutes)...
          </span>
        </div>
        <div class="w-full space-y-6 p-4">
          <!-- Episode section -->
          <div class="mb-5 border-l-4 border-gray-100 pl-4">
            <p-skeleton height="20px" width="40%" styleClass="mb-3" />
            <div class="pl-4">
              <p-skeleton height="14px" width="95%" styleClass="mb-2" />
              <p-skeleton height="14px" width="100%" styleClass="mb-2" />
              <p-skeleton height="14px" width="90%" styleClass="mb-2" />
              <p-skeleton height="14px" width="85%" styleClass="mb-2" />
            </div>
          </div>

          <!-- Another episode section -->
          <div class="border-l-4 border-gray-100 pl-4">
            <p-skeleton height="20px" width="35%" styleClass="mb-3" />
            <div class="pl-4">
              <p-skeleton height="14px" width="90%" styleClass="mb-2" />
              <p-skeleton height="14px" width="100%" styleClass="mb-2" />
              <p-skeleton height="14px" width="88%" styleClass="mb-2" />
            </div>
          </div>
        </div>
      }
    </form>
  </div>
</div>
